__turbopack_context__.v({
  "book-box": "styles-module__Xrwl9q__book-box",
  "book-city": "styles-module__Xrwl9q__book-city",
  "header-down": "styles-module__Xrwl9q__header-down",
  "header-up": "styles-module__Xrwl9q__header-up",
  "hide": "styles-module__Xrwl9q__hide",
  "show": "styles-module__Xrwl9q__show",
  "underline": "styles-module__Xrwl9q__underline",
  "underline-active": "styles-module__Xrwl9q__underline-active",
});
